import { RightOutlined } from "@ant-design/icons";
import { Button, Col, Form, PageHeader, Row, Select, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import ProgrammeService from '../../api/programme.service'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PaymentPaidList from '../../components/payment/PaymentPaidList'
import { SUCCESS_STATUS } from '../../utility/Constants'
const { Option } = Select;


const PaymentList = () => {
    const [form] = Form.useForm();
    const [programmeList, setProgrammeList] = useState([]);
    const [selectedProgrammeID, setSelectedProgrammeID] = useState(0);



    const onProgrammeSelect = (value, event) => {
    
        const programme_id = form.getFieldValue("programme_id");
        setSelectedProgrammeID(programme_id)
    
      };

    useEffect(() => {
        ProgrammeService.programmeList().then((res) => {
            console.log(res);
            if (res.data.response_status === SUCCESS_STATUS) {
                setProgrammeList(res.data.response_data);
            }

        });
    }, []);

  return (
    <div>


<div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Payment Received List"
          subTitle=""
          
        ></PageHeader>

<div className="tableView">

        <div className="form-content">

        <Row className="" style={{ background: "transparent" }}>
                  <Col className="" xs={24} xl={12}>
                      <Form
                          form={form}
                          layout="vertical"
                     
                          autoComplete="off"
                      // initialValues={formDefaultValues}
                      >

                          <Row gutter={20}>
                              
                          <Col xs={24} xl={12} style={{margin:"0.5rem"}}>
                                    <Form.Item name="programme_id" label="Programme" rules={[
                                        {
                                            required: true,
                                            message: 'Programme is required',
                                        },
                                    ]}>
                                        <Select className="text-left" onSelect={(value, event) =>onProgrammeSelect(value, event)} >

                                            {
                                                programmeList.length > 0 ?
                                                    programmeList.map(programme_data => (
                                                        <Option key={programme_data.programme_id} value={programme_data.programme_id}>{programme_data.programme_name}</Option>

                                                    ))
                                                    : ''
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>

                              

                       
                             



                          </Row>
                      </Form>



                  </Col>
              </Row>
            
                
                <PaymentPaidList programme_id = {selectedProgrammeID}/>
                
           
        </div>
        </div>

      </div>
    </div>

    </div>


  )
}

export default PaymentList